import jwt_decode from "jwt-decode";

const MAX_NIVELES = 5;

/**
 * Si el usuario esta dentro de otra cuenta (ownToken), devuelve quien inicio sesion realmente,
 * siguiendo la cadena (ADMIN -> matriz -> oficina => ADMIN). Igual que el back (services/chatElite/actor.js).
 * @returns {{ rol, nombre } | null} null si no hay suplantacion
 */
export const getUsuarioOriginal = (user) => {
  let token = user?.ownData?.token;
  if (!token) return null;
  let actual = null;
  try {
    for (let i = 0; i < MAX_NIVELES && token; i++) {
      actual = jwt_decode(token);
      token = actual?.data?.ownToken;
    }
  } catch (_) {
    return null;
  }
  if (!actual) return null;
  const nombre = [actual.data?.nombre, actual.data?.apellidos].filter(Boolean).join(" ") || actual.email;
  return { rol: actual.rol, nombre };
};

/**
 * Solo cuenta como "suplantacion" si el usuario real no es otro AAFF (una matriz dentro de su
 * oficina escribe como la oficina).
 */
export const getSuplantadorChatElite = (user) => {
  const original = getUsuarioOriginal(user);
  return original && original.rol !== "AAFF" ? original : null;
};

// TEMPORAL: Chat Élite oculto (widget del AAFF, panel y botón del equipo; en Tu IA Normativa el soporte sale como
// "próximamente"). Para volver a mostrarlo: true (y CHAT_ELITE_VISIBLE en el back, constants/chatElite.js)
export const CHAT_ELITE_VISIBLE = false;

export const puedeUsarWidgetChatElite = (user) => CHAT_ELITE_VISIBLE && user?.rol === "AAFF" && user?.legalia === "Elite";
